import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "10 17 15 12 10 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "3", y1: "12", y2: "12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LogIn";
const LogIn = memo(themed(Icon));
export {
  LogIn
};
//# sourceMappingURL=log-in.js.map
